<template>
  <div class="page__body">
    <section id="body--text" v-if="countryData != null">
      <div class="row">
        <div class="columns small-12" id="grid-chart-top">
          <h2>Novos casos por um milhão de habitantes</h2>
          <!-- <p>
            Número total de novos casos num dia por 1.000.000 habitantes em seis
            países europeus.
          </p> -->

          <div id="box_legenda">
            <p>
              <svg height="10" width="20">
                <line
                  x1="0"
                  y1="5"
                  x2="15"
                  y2="5"
                  style="stroke:rgb(237, 28, 36);stroke-width:3"
                />
              </svg>
              Média móvel a sete dias de novos casos diários por um milhão de
              habitantes
            </p>
            <p>
              <svg height="20" width="20">
                <circle cx="10" cy="14" r="3" fill="#fbb67c" />
              </svg>
              Número de novos casos diários por um milhão de habitantes
            </p>
          </div>
        </div>
      </div>
      <div class="row" id="charts">
        <div class="columns small-12 medium-6 large-4 chart portugal">
          <h3>{{ countryData.portugal.name }}</h3>
          <MainChart
            :dates="countryData.days"
            :data="countryData.portugal.data_novos_casos"
            :name="countryData.portugal.name"
            :dataScatter="countryData.portugal.data_real"
            :max="countryData.max"
          />
        </div>
        <div class="columns small-12 medium-6 large-4 chart">
          <h3>{{ countryData.espanha.name }}</h3>

          <MainChart
            :dates="countryData.days"
            :data="countryData.espanha.data_novos_casos"
            :name="countryData.espanha.name"
            :dataScatter="countryData.espanha.data_real"
            :max="countryData.max"
          />
        </div>

        <div class="columns small-12 medium-6 large-4 rows-medium chart">
          <h3>{{ countryData.reino_unido.name }}</h3>

          <MainChart
            :dates="countryData.days"
            :data="countryData.reino_unido.data_novos_casos"
            :name="countryData.reino_unido.name"
            :dataScatter="countryData.reino_unido.data_real"
            :max="countryData.max"
          />
        </div>

        <div
          class="columns small-12 medium-6 large-4 snd-row rows-medium chart"
        >
          <h3>{{ countryData.belgica.name }}</h3>

          <MainChart
            :dates="countryData.days"
            :data="countryData.belgica.data_novos_casos"
            :name="countryData.belgica.name"
            :dataScatter="countryData.belgica.data_real"
            :max="countryData.max"
          />
        </div>

        <div
          class="columns small-12 medium-6 large-4 snd-row rows-medium chart"
        >
          <h3>{{ countryData.alemanha.name }}</h3>

          <MainChart
            :dates="countryData.days"
            :data="countryData.alemanha.data_novos_casos"
            :name="countryData.alemanha.name"
            :dataScatter="countryData.alemanha.data_real"
            :max="countryData.max"
          />
        </div>

        <div
          class="columns small-12 medium-6 large-4 snd-row rows-medium chart"
        >
          <h3>{{ countryData.franca.name }}</h3>
          <MainChart
            :dates="countryData.days"
            :data="countryData.franca.data_novos_casos"
            :name="countryData.franca.name"
            :dataScatter="countryData.franca.data_real"
            :max="countryData.max"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MainChart from "../components/chart/mainChart.vue";

export default {
  name: "ChartGrid",
  components: {
    MainChart,
  },
  data() {
    return {
      countryData: null,
    };
  },
  created: function() {
    fetch(
      "https://raw.githubusercontent.com/ruimgbarros/post-christmas-covid/master/data.json?v2"
    )
      .then((r) => r.json())
      .then((json) => {
        this.countryData = json;
      });
  },
};
</script>

<style scoped>
.portugal {
  background-color: #f8f8f8;
  /* font-weight: 900 !important; */
}
#grid-chart-top {
  text-align: center;
  margin-bottom: 60px;
}
#grid-chart-top h2 {
  font-family: giorgiosans-medium, Helvetica, Arial, sans-serif;
  font-size: 2rem;
  margin-bottom: 0px;
}

#grid-chart-top p {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 1rem;
  margin-bottom: 5px;
}

#box_legenda p {
  font-size: 0.9rem;
  margin-bottom: -5px;
  line-height: 0.8rem;
}

#charts > div > h3 {
  padding-top: 20px;
  font-family: giorgiosans-medium, Helvetica, Arial, sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: #777;
  font-size: 1.5rem;
  line-height: 0.88;
  margin-bottom: 0;
}

#charts > div > p {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.8rem;
  text-align: center;
  margin-bottom: 20px;
  opacity: 0.6;
  line-height: 1rem;
  margin-bottom: 5px;
}

.info1 {
  height: 80px;
}

@media screen and (min-width: 64em) {
  .snd-row {
    margin-top: 20px;
  }
}

@media screen and (min-width: 40em) and (max-width: 63.9375em) {
  .rows-medium {
    margin-top: 40px;
  }
}

@media screen and (max-width: 39.9375em) {
  .chart {
    margin-bottom: 20px;
  }
  .info1 {
    height: 60px;
  }
}
</style>
